import { PasswordReg } from '@/utils/commonReg'
//校验密码
export const passwordvali = (rule, value, callback) => {
  const reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/;
  // var reg=/^(?=.*\d)(?=.*[a-zA-Z])[\da-zA-Z~!@#$%^&*.,]{8,12}$/
  if (value === "") {
    callback("请输入密码");
  } else if (!reg.test(value)) {
    callback(new Error("请输入8-16位的数字和字母组合的密码"));
  } else {
    callback();
  }
};

/**
 * @description: 校验密码是否符合规范
 */
export const passwordValidator = (rule, value, callback) => {
  if (!PasswordReg.test(value)) {
    callback(new Error("密码不符合规范"));
  } else {
    callback();
  }
};

/**
 * @description: 校验身份证是否正确
 */
export const isChineseIdCard = (idCard) => {
  const powers = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
  const parityBit = ["1", "0", "X", "9", "8", "7", "6", "5", "4", "3", "2"];
  const provinceCode = {
    11: "北京",
    12: "天津",
    13: "河北",
    14: "山西",
    15: "内蒙古",
    21: "辽宁",
    22: "吉林",
    23: "黑龙江",
    31: "上海",
    32: "江苏",
    33: "浙江",
    34: "安徽",
    35: "福建",
    36: "江西",
    37: "山东",
    41: "河南",
    42: "湖北",
    43: "湖南",
    44: "广东",
    45: "广西",
    46: "海南",
    50: "重庆",
    51: "四川",
    52: "贵州",
    53: "云南",
    54: "西藏",
    61: "陕西",
    62: "甘肃",
    63: "青海",
    64: "宁夏",
    65: "新疆",
    71: "台湾",
    81: "香港",
    82: "澳门",
    91: "国外",
  };

  // 验证身份证号码的长度和格式是否正确
  if (idCard.length !== 18) return false;
  if (!/^\d{17}(\d|x)$/i.test(idCard)) return false;

  // 验证身份证号码的省份代码是否正确
  if (!provinceCode[idCard.substr(0, 2)]) return false;

  // 验证身份证号码的出生日期是否正确
  const birthdate = idCard.substr(6, 8);
  const year = birthdate.substr(0, 4);
  const month = birthdate.substr(4, 2);
  const day = birthdate.substr(6, 2);
  const date = new Date(year, parseFloat(month) - 1, parseFloat(day));
  if (
    date.getFullYear() !== parseFloat(year) ||
    date.getMonth() !== parseFloat(month) - 1 ||
    date.getDate() !== parseFloat(day)
  ) {
    return false;
  }

  // 验证身份证号码的校验位是否正确
  let s = 0;
  for (let i = 0; i < 17; i++) {
    s += idCard.charAt(i) * powers[i];
  }
  if (parityBit[s % 11] !== idCard.charAt(17).toUpperCase()) return false;
  // 身份证号码校验通过
  return true;
};



// WEBPACK FOOTER //
// ./src/utils/validate.js